import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { enableRipple } from '@syncfusion/ej2-base';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { environment } from '../environments/environment';

enableRipple(true);

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import { MainService } from './Service/main.service';
import { DataService } from './Service/data.service';
import { DashboardGuard } from './Dashboard.guard';
// import { UsersModule } from './adminUsers/users/users.module';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';

import { ReportGrievanceComponent } from './tenant/report-grievance/report-grievance.component';
import { ReportRequestComponent } from './tenant/report-request/report-request.component';
import { TenantSettingsComponent } from './tenant/tenant-feedback_bkp/tenant-settings.component';
import { TanetFeedbackComponent } from './tenant/tanet-feedback/tanet-feedback.component';
import { DatePipe, CurrencyPipe, PercentPipe } from '@angular/common';
import { DvAuthLoginComponent } from './tenant/dv-auth-login/dv-auth-login.component';
import { RefreshService } from './refresh.service';
// import { PaginationModule } from "./pagination/pagination.module";
// import { LogsComponent } from './adminUsers/logs/logs.component';

// import { TenantManagementComponent } from './subscriberUsers/tenant-management/tenant-management.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    // bgsColor: '#00ACC1',
    fgsColor: '#fff',
    // pbColor: 'red',
    // bgsPosition: POSITION.bottomCenter,
    bgsSize: 40,
    bgsType: SPINNER.rectangleBounce,
    pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
    pbThickness: 0, // progress bar thickness
};

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function loadGooglePlacesApi(document: Document) {
    return () => {
        const globalWindow = window as typeof window & {
            google?: unknown;
        };

        if (globalWindow.google) {
            return Promise.resolve();
        }

        const apiKey = (environment.googleMapsApiKey || '').trim();

        if (!apiKey || apiKey === 'YOUR_GOOGLE_MAPS_API_KEY') {
            return Promise.resolve();
        }

        const existingScript = document.querySelector('script[data-google-places-api="true"]') as HTMLScriptElement | null;

        if (existingScript) {
            return Promise.resolve();
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.dataset.googlePlacesApi = 'true';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`;
        document.head.appendChild(script);

        return Promise.resolve();
    };
}

@NgModule({
    declarations: [
        AppComponent,
        ReportGrievanceComponent,
        ReportRequestComponent,
        TenantSettingsComponent,
        TanetFeedbackComponent,
        DvAuthLoginComponent,
        // LogsComponent,
        // MultiplierPipe,

    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        HttpModule,
        BrowserAnimationsModule, // required for ng2-tag-input
        GooglePlaceModule,
        CoreModule,
        LayoutModule,
        SharedModule.forRoot(),
        RoutesModule,
        DropDownButtonModule,
        FormsModule,
        ReactiveFormsModule,
        // PdfViewerModule,
        // UsersModule,
        // ManageSubscribersComponentModule,
        // ManagePropertiesComponentModule,
        // RecoverComponentModule,
        NgMultiSelectDropDownModule.forRoot(),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        MainService,
        DataService,
        RefreshService,
        DashboardGuard,
        {
            provide: APP_INITIALIZER,
            useFactory: loadGooglePlacesApi,
            deps: [DOCUMENT],
            multi: true
        },
        DatePipe,
        CurrencyPipe,
        PercentPipe,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
